var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/account.tsx";
import * as React from 'react';
import { Link, useHistory } from 'react-router-dom';
import HoverRefWrapper from 'soapbox/components/hover_ref_wrapper';
import VerificationBadge from 'soapbox/components/verification_badge';
import ActionButton from 'soapbox/features/ui/components/action-button';
import { useAppSelector, useOnScreen } from 'soapbox/hooks';
import { getAcct } from 'soapbox/utils/accounts';
import { displayFqn } from 'soapbox/utils/state';
import RelativeTimestamp from './relative_timestamp';
import { Avatar, EmojiReact, HStack, Icon, IconButton, Stack, Text } from './ui';
export const InstanceFavicon = ({
  account
}) => {
  const history = useHistory();
  const handleClick = e => {
    e.stopPropagation();
    history.push(`/timeline/${account.domain}`);
  };
  return /*#__PURE__*/React.createElement("button", {
    className: "w-4 h-4 flex-none focus:ring-primary-500 focus:ring-2 focus:ring-offset-2",
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: account.favicon,
    alt: "",
    title: account.domain,
    className: "w-full max-h-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }));
};
export const ProfilePopper = ({
  condition,
  wrapper,
  children
}) => condition ? wrapper(children) : children;
const Account = ({
  account,
  actionType,
  action,
  actionIcon,
  actionTitle,
  actionAlignment = 'center',
  avatarSize = 42,
  hidden = false,
  hideActions = false,
  onActionClick,
  showProfileHoverCard = true,
  timestamp,
  timestampUrl,
  futureTimestamp = false,
  withAccountNote = false,
  withDate = false,
  withLinkToProfile = true,
  showEdit = false,
  className,
  emoji
}) => {
  const overflowRef = React.useRef(null);
  const actionRef = React.useRef(null);
  const isOnScreen = useOnScreen(overflowRef);
  const [style, setStyle] = React.useState({
    visibility: 'hidden'
  });
  const me = useAppSelector(state => state.me);
  const username = useAppSelector(state => account ? getAcct(account, displayFqn(state)) : null);
  const handleAction = React.useCallback(() => {
    onActionClick(account);
  }, [onActionClick, account]);
  const renderAction = React.useCallback(() => {
    if (action) {
      return action;
    }
    if (hideActions) {
      return null;
    }
    if (onActionClick && actionIcon) {
      return /*#__PURE__*/React.createElement(IconButton, {
        src: actionIcon,
        title: actionTitle,
        onClick: handleAction,
        className: "bg-transparent text-gray-600 dark:text-gray-600 hover:text-gray-700 dark:hover:text-gray-500",
        iconClassName: "w-4 h-4",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117,
          columnNumber: 9
        }
      });
    }
    if (account.id !== me) {
      return /*#__PURE__*/React.createElement(ActionButton, {
        account: account,
        actionType: actionType,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128,
          columnNumber: 14
        }
      });
    }
    return null;
  }, [action, hideActions, onActionClick, actionIcon, actionTitle, handleAction, account, me, actionType]);
  React.useEffect(() => {
    const style = {};
    const actionWidth = actionRef.current?.clientWidth || 0;
    if (overflowRef.current) {
      style.maxWidth = overflowRef.current.clientWidth - 30 - avatarSize - actionWidth;
    } else {
      style.visibility = 'hidden';
    }
    setStyle(style);
  }, [isOnScreen, overflowRef, actionRef, avatarSize]);
  const LinkEl = React.useMemo(() => withLinkToProfile ? Link : 'div', [withLinkToProfile]);
  const internalTimestamp = React.useMemo(() => withDate ? account.created_at : timestamp, [timestamp, withDate]);
  if (!account) {
    return null;
  }
  if (hidden) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, account.display_name, account.username);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "account",
    className: `shrink-0 group block w-full ${className}`,
    ref: overflowRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 165,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: actionAlignment,
    justifyContent: "between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    className: "grow min-w-0",
    alignItems: withAccountNote ? 'top' : 'center',
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ProfilePopper, {
    condition: showProfileHoverCard,
    wrapper: children => /*#__PURE__*/React.createElement(HoverRefWrapper, {
      className: "relative",
      accountId: account.id,
      inline: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 170,
        columnNumber: 36
      }
    }, children),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LinkEl, {
    to: `/@${account.acct}`,
    title: account.acct,
    onClick: event => event.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: account.avatar,
    size: avatarSize,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 15
    }
  }), emoji && /*#__PURE__*/React.createElement(EmojiReact, {
    className: "w-5 h-5 absolute -bottom-1.5 -right-1.5",
    emoji: emoji,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grow min-w-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 187,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ProfilePopper, {
    condition: showProfileHoverCard,
    wrapper: children => /*#__PURE__*/React.createElement(HoverRefWrapper, {
      accountId: account.id,
      inline: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 190,
        columnNumber: 38
      }
    }, children),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(LinkEl, {
    to: `/@${account.acct}`,
    title: account.acct,
    onClick: event => event.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-1 flex-grow",
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    weight: "semibold",
    truncate: true,
    dangerouslySetInnerHTML: {
      __html: account.display_name_html
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 198,
      columnNumber: 19
    }
  }), account.verified && /*#__PURE__*/React.createElement(VerificationBadge, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 205,
      columnNumber: 40
    }
  })))), /*#__PURE__*/React.createElement(Stack, {
    space: withAccountNote ? 1 : 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    className: "grow",
    alignItems: "center",
    space: 1,
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    truncate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 17
    }
  }, "@", username), account.favicon && /*#__PURE__*/React.createElement(InstanceFavicon, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 19
    }
  }), internalTimestamp ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 21
    }
  }, "\xB7"), timestampUrl ? /*#__PURE__*/React.createElement(Link, {
    to: timestampUrl,
    className: "hover:underline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 23
    }
  }, /*#__PURE__*/React.createElement(RelativeTimestamp, {
    timestamp: internalTimestamp,
    theme: "muted",
    size: "sm",
    className: "whitespace-nowrap",
    futureDate: futureTimestamp,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 25
    }
  })) : /*#__PURE__*/React.createElement(RelativeTimestamp, {
    timestamp: internalTimestamp,
    theme: "muted",
    size: "sm",
    className: "whitespace-nowrap",
    futureDate: futureTimestamp,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227,
      columnNumber: 23
    }
  })) : null, showEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 234,
      columnNumber: 21
    }
  }, "\xB7"), /*#__PURE__*/React.createElement(Icon, {
    className: "h-5 w-5 text-gray-700 dark:text-gray-600",
    src: require('@tabler/icons/pencil.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 236,
      columnNumber: 21
    }
  })) : null), withAccountNote && /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    dangerouslySetInnerHTML: {
      __html: account.note_emojified
    },
    className: "mr-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 242,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement("div", {
    ref: actionRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 9
    }
  }, renderAction())));
};
export default Account;